const TrafficPlan = () =>
  import(
    /* webpackChunkName: "base-info-geo-traffic-plan" */ '@/pages/base-info/geo/traffic-plan/index.vue'
  )
const CreateTrafficPlan = () =>
  import(
    /* webpackChunkName: "base-info-geo-traffic-plan" */ '@/pages/base-info/geo/traffic-plan/create.vue'
  )
const EditTrafficPlan = () =>
  import(
    /* webpackChunkName: "base-info-geo-traffic-plan" */ '@/pages/base-info/geo/traffic-plan/edit.vue'
  )

export default {
  path: 'traffic-plan',
  meta: {
    label: 'trafficPlan',
    auth: 'trafficPlan'
  },
  component: {
    name: 'TrafficPlan',
    render(c) {
      return c('router-view')
    }
  },
  children: [
    {
      name: 'BaseInfoGeoTrafficPlan',
      path: '/',
      meta: {
        label: 'report',
        auth: 'report'
      },
      component: TrafficPlan
    },
    {
      name: 'BaseInfoCreateGeoTrafficPlan',
      path: 'create',
      meta: {
        label: 'create',
        auth: 'create'
      },
      component: CreateTrafficPlan
    },
    {
      name: 'BaseInfoEditGeoTrafficPlan',
      path: 'edit/:id',
      meta: {
        label: 'edit',
        auth: 'update'
      },
      component: EditTrafficPlan,
      props: true
    }
  ]
}
